/*
Contains all the routes pertaining to Dashboard Layout
Use the following structure: 
export const {name}Route = {
  ID: "",
  path: "/",
  element: "",
  index: true, (if the path is default for some folder)
}
*/

//Misc Pages
import Page404 from "../../pages/misc/Page404";
import pages from "../../constants/pages";

//Test Page

const emptyLayoutRoutes = {
  //Error 404
  error404Route: {
    ID: "error404",
    path: "*",
    element: Page404,
  },

  //Test page
};

export default emptyLayoutRoutes;
